'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$LoginViaEmailLinkRequest(email, url) {
  this.Zl = null;
  this.Zm = null;
  this.Zl = email;
  this.Zm = url;
}
export { $c_Lpresto_types$proto$LoginViaEmailLinkRequest as $c_Lpresto_types$proto$LoginViaEmailLinkRequest };
$p = $c_Lpresto_types$proto$LoginViaEmailLinkRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$LoginViaEmailLinkRequest;
/** @constructor */
function $h_Lpresto_types$proto$LoginViaEmailLinkRequest() {
}
export { $h_Lpresto_types$proto$LoginViaEmailLinkRequest as $h_Lpresto_types$proto$LoginViaEmailLinkRequest };
$h_Lpresto_types$proto$LoginViaEmailLinkRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$LoginViaEmailLinkRequest) && ((this.Zl === x$0.Zl) && (this.Zm === x$0.Zm))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "LoginViaEmailLinkRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Zl;
  }
  if ((n === 1)) {
    return this.Zm;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$LoginViaEmailLinkRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lk)));
}
export { $isArrayOf_Lpresto_types$proto$LoginViaEmailLinkRequest as $isArrayOf_Lpresto_types$proto$LoginViaEmailLinkRequest };
var $d_Lpresto_types$proto$LoginViaEmailLinkRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$LoginViaEmailLinkRequest, "presto.types$proto$LoginViaEmailLinkRequest", ({
  lk: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$LoginViaEmailLinkRequest as $d_Lpresto_types$proto$LoginViaEmailLinkRequest };
//# sourceMappingURL=presto.types$proto$-Login-Via-Email-Link-Request.js.map
